import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormRadioField, {
  MxFormRadioFieldProps
} from "@rf-l2/form/text-fields/MxFormRadioField";

export interface MxFormL3RadioFieldProps extends MxFormRadioFieldProps {
  name: string;
  withreacthookform?: 1 | 0;
}

const MxFormL3RadioField = (props: MxFormL3RadioFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormRadioField {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3RadioField;
